import { render, staticRenderFns } from "./InputAsset2.vue?vue&type=template&id=3823d2b6"
import script from "./InputAsset2.vue?vue&type=script&lang=js"
export * from "./InputAsset2.vue?vue&type=script&lang=js"
import style0 from "./InputAsset2.vue?vue&type=style&index=0&id=3823d2b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports